// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"cbf55d12","513":"7cbf5356","703":"70aa5837","787":"22edae46"}[chunkId] + ".chunk.js";
};